import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as actionCreators from "../actions/actionCreators.js";


import PublicReport from "../components/PublicReport";


function mapStateToProps(state){
	//console.log("Connecting state", state.series);
	return {
		lang: state.data.lang,
		auth: state.data.auth
	}
}

function mapDispatchToProps(dispatch){
	return bindActionCreators(actionCreators, dispatch);
}


const PublicReportContainer = connect(mapStateToProps, mapDispatchToProps)(PublicReport);

export default PublicReportContainer;


// WEBPACK FOOTER //
// ./src/containers/PublicReportContainer.js